// src/properties/houseRulesApi.ts
import { apiClient } from "@maat/api-base";
var houseRulesApi = {
  async getHouseRules() {
    return await apiClient.get("/main/api/house-rules");
  }
};

export {
  houseRulesApi
};
